// extracted by mini-css-extract-plugin
module.exports = {"colorCardContainer":"ItemCard_colorCardContainer__yGp-Q","colorCardTitle":"ItemCard_colorCardTitle__3JkD9"};